import request from "../request";

/**
 * @param {number} orderId
 * @param {('code' | 'phone' | 'email')} type
 * @param {string} value
 * @return {Promise<{ result: Boolean }>}
 */
export const checkFan = (orderId, type, value) => {
  return request({
    url: `/orders/check-fan`,
    type: 'GET',
    data: {
      orderId,
      type,
      value
    }
  })
};

/**
 * @return {Promise<import("../types/cart").Order[]>}
 */
export const getCart = () => {
  return request({
    url: "/orders/ajax-cart",
    type: "GET",
  });
};

/**
 * @param {Object} params
 */
export const getHistory = (params = {}) => request({
	url: '/orders/ajax-history',
	type: 'GET',
	data: params || {},
});
export const getBarCodes = (orderId, cartId) => {
  return request({
    url: `/orders/barcode`,
    type: "GET",
    data: {
      order_id: orderId,
      cart_id: cartId,
    }
  });
};
